/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-05-19 17:16:40
 */
import React, { Component } from 'react'
import './index.css'

import { Form, Input, Button } from 'antd';

class MyProcessOrder extends Component {

    componentDidMount(){
        // debugger
    }
    render() {
        return (
            <div>
             我的生产订单页面
            </div>
        )
    }
}

export default MyProcessOrder